import { render } from "./inner-fashion.vue?vue&type=template&id=e1a5ae08"
import script from "./inner-fashion.vue?vue&type=script&lang=js"
export * from "./inner-fashion.vue?vue&type=script&lang=js"

import "./inner-fashion.vue?vue&type=style&index=0&id=e1a5ae08&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__